export default __webpack_public_path__ + "static/media/Nishant - Nishant Giri.a5e9d224.jpg";